import {
  Box,
  Button,
  CircularProgress,
  Divider,
  InputAdornment,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
// import Switch from 'rc-switch'
import "rc-switch/assets/index.css";
import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  formatDate,
  getToken,
  getWebsite,
  isArrayWithValues,
  isObjWithValues,
  TabPanel,
} from "../../../../helper";
import { setGlobalToast } from "../../../../redux/actions/helperActions";
import { useDispatch, useSelector } from "react-redux";
import { EDIT_SETTINGS } from "../../../../redux/actions/settingActions";
import { LoadingButton } from "@mui/lab";
import { Lock } from "@mui/icons-material";
import Overview from "./Overview";

const TryBeforeYouBut = () => {
  const [selectedTab, setSelectedTab] = useState("overview");
  const [keyInput, setKeyInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [isIntegreated, setIsIntegreated] = useState(false);
  const [integratedDate, setIntegratedDate] = useState(false);
  // const [isCamweraIntegrated, setIsCamweraIntegrated] = useState(false);
  const globalToast = useSelector((state) => state.helper.globalToast);
  const dispatch = useDispatch();
  // const camwearaIntegration = useSelector(
  //   (state) => state.settings.camwearaIntegration
  // );
  const virtualTryIntegrated = useSelector(
    (state) => state.helper.virtualTryIntegrated
  );
  // useEffect(() => {
  //   if (isObjWithValues(camwearaIntegration)) {
  //     if (camwearaIntegration?.key) {
  //       setIsCamweraIntegrated(true);
  //     } else {
  //       setIsCamweraIntegrated(false);
  //     }
  //   }
  // }, [camwearaIntegration]);
  const reduxTrybeforeyoubuyIntegration = useSelector(
    (state) => state.settings.trybeforeyoubuyIntegration
  );
  console.log(reduxTrybeforeyoubuyIntegration);
  useEffect(() => {
    console.log(reduxTrybeforeyoubuyIntegration);
    if (isObjWithValues(reduxTrybeforeyoubuyIntegration)) {
      if (reduxTrybeforeyoubuyIntegration?.key) {
        setKeyInput(reduxTrybeforeyoubuyIntegration?.key || "");
        setIsIntegreated(true);
        setIntegratedDate(reduxTrybeforeyoubuyIntegration?.time || "");
      } else {
        setKeyInput("");
        setIsIntegreated(false);
        setIntegratedDate(false);
      }
    }
  }, [reduxTrybeforeyoubuyIntegration]);

  const verifykey = async () => {
    let website = getWebsite();
    let token = getToken();
    if (!website && !token) return false
    setLoading(true);
    let body = new FormData();
    body.append("name", "Vendor_Auth_UniqueKey");
    body.append("unique_id", keyInput);
    let res = await axios({
      url: `https://tryb4ubuy.in/TRY_Portal/Prod/TRYb4uBUY_Service/index_browser.php`,
      method: "POST",
      data: body,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (isArrayWithValues(res.data) && res.data[0].status === "Successfull") {
      let time = Date.now();
      let IntegartionData = await axios({
        url: `${website}/wp-json/store/v1/settings/tryb4ubuy_integration`,
        headers: {
          Authorization: `Basic ${token}`,
        },
        data: {
          type: "tryb4ubuy_integration",
          data: {
            time,
            key: keyInput,
          },
        },
        method: "PUT",
      });
      dispatch(
        setGlobalToast({
          ...globalToast,
          show: true,
          message: "Vendor Authorised succesfully",
        })
      );
      dispatch({
        type: EDIT_SETTINGS,
        payload: {
          trybeforeyoubuyIntegration: {
            time,
            key: keyInput,
          },
        },
      });
    } else {
      dispatch(
        setGlobalToast({
          ...globalToast,
          show: true,
          message: "Vendor Authorised failed",
        })
      );
    }
    console.log(res.data);
    setLoading(false);
  };
  const revokeKey = async () => {
    let website = getWebsite();
    let token = getToken();
    if (!website && !token) return false
    setLoading(true);
    let IntegartionData = await axios({
      url: `${website}/wp-json/store/v1/settings/tryb4ubuy_integration`,
      headers: {
        Authorization: `Basic ${token}`,
      },
      data: {
        type: "tryb4ubuy_integration",
        data: {
          time: "",
          key: "",
        },
      },
      method: "PUT",
    });
    console.log(IntegartionData);
    if (IntegartionData.data.success)
      dispatch({
        type: EDIT_SETTINGS,
        payload: {
          trybeforeyoubuyIntegration: IntegartionData.data.data,
        },
      });
    setLoading(false);
  };
  return (
    <Box sx={{ height: "100%", paddingRight: "15px" }}>
      <Stack
        sx={{
          position: "sticky",
          top: "0",
          backgroundColor: "#fff",
          zIndex: 13,
          margin: 0,
          padding: "12px",
        }}
      >
        <Stack
          direction="row"
          justifyContent={"space-between"}
          alignItems="center"
        >
          <Typography
            variant="h3"
            sx={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            {" "}
            <img
              src="/static/img/brands/tryb4ubuy.png"
              width="20px"
              height="20px"
            />{" "}
            Tryb4ubuy
          </Typography>
          {/* {fetchingMetaIntegration && <Stack direction={"row"} alignItems="center" sx={{ gap: "10px" }}>
                        <CircularProgress size={"15px"} /> <Typography>Fetching Integrations...</Typography>
                    </Stack>} */}
        </Stack>
        {/* <Divider sx={{ mt: 4 }} /> */}
        <Tabs
          onChange={(e, newValue) => setSelectedTab(newValue)}
          value={selectedTab}
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab label="Overview" value="overview" />
          {/* <Tab label="How to do?" value="how_to_do" />
                    <Tab label="Details" value="details" /> */}
          <Tab label="Integration" value="integration" />
          {/* <Tab label="Settings" value="settings" /> */}
        </Tabs>
      </Stack>
      <TabPanel value={selectedTab} index={"overview"}>
        <Typography><Overview /></Typography>
      </TabPanel>
      <TabPanel value={selectedTab} index={"how_to_do"}>
        <Typography>How to do</Typography>
      </TabPanel>
      <TabPanel value={selectedTab} index={"details"}>
        <Typography>Details</Typography>
      </TabPanel>
      <TabPanel value={selectedTab} index={"integration"}>
        <Box sx={{ padding: "12px 18px" }}>
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "30px" }}>
            <Typography
              variant="h6"
            // fontSize={"13px"}
            // mt={3}
            >
              Tryb4ubuy Key
            </Typography>
          </Stack>
          <Stack
            direction={"row"}
            alignItems="center"
            sx={{ gap: "20px", mt: 2 }}
          >
            <TextField
              value={keyInput}
              onChange={(e) => setKeyInput(e.target.value)}
              // variant="outlined"
              size="small"
              sx={{ width: "350px" }}
              // fullWidth
              // sx={{ mt: 2 }}
              disabled={isIntegreated}
              InputProps={
                isIntegreated
                  ? {
                    endAdornment: (
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    ),
                  }
                  : null
              }
            />
            {!isIntegreated ? (
              <LoadingButton
                size="small"
                loading={loading}
                // disabled={isCamweraIntegrated}
                disabled={virtualTryIntegrated}
                variant="contained"
                onClick={verifykey}
              >
                Integrate
              </LoadingButton>
            ) : null}
            {isIntegreated ? (
              <LoadingButton
                size="small"
                color="error"
                loading={loading}
                variant="contained"
                onClick={revokeKey}
              >
                Revoke
              </LoadingButton>
            ) : null}
          </Stack>

          {integratedDate ? (
            <Typography sx={{ mt: 2 }}>
              {" "}
              Integrated on{" "}
              {formatDate(new Date(integratedDate), "relative_date")}
            </Typography>
          ) : null}
        </Box>
      </TabPanel>
    </Box>
  );
};

export default TryBeforeYouBut;
